<script lang="ts">
	import Instruction from './steps/Instructions.svelte'
	import WordsRating from './steps/WordsRating.svelte'
	import {v4 as uuidv4} from 'uuid'
	import Text from './Text.svelte'
	import shuffle from 'array-shuffle'
	import instructions from './steps/Instructions'
	import Questions from './questions/Questions.svelte'
	import Loading from './Loading.svelte'

	let step = 0

	let formId: number
	let wordsListNumber: number
	let newListAvailable: boolean
	let words: string[] = []
	let error = ""
	let loading = true

	const getId = async () => {
		const URLquery = new URLSearchParams(document.location.search)
		const isRedo = URLquery.has('redo')
		let listId
		let nbRedo = 0
		const nbLists = 12
		const nbForms = 1
		if (isRedo) {
			nbRedo = Number(sessionStorage.getItem('redo')) + 1
			formId = Number(sessionStorage.getItem('formId'))
			listId = sessionStorage.getItem('listId')
			sessionStorage.setItem('redo', nbRedo.toString())
		} else {
			const nextFormIdReq = await fetch('backend.php')
			if (nextFormIdReq.status >= 400) {
				formId = Math.floor(Math.random() * nbForms)
				listId = Math.floor(Math.random() * nbLists)
			} else {
				const nextFormIdJson = await nextFormIdReq.json()
				formId = nextFormIdJson.formId
				listId = nextFormIdJson.listId
			}
			sessionStorage.setItem('formId', formId.toString())
			sessionStorage.setItem('listId', listId)
			sessionStorage.setItem('redo', '0')
		}
		newListAvailable = nbRedo < nbLists
		wordsListNumber = listId + nbRedo

		const fetchedWords = (await import('/words/Liste' + (wordsListNumber) + '.js')).default
		words = shuffle(words.concat(fetchedWords))
		loading = false

		if (isRedo) {
			uuid = sessionStorage.getItem('session-id')
		} else {
			sessionStorage.setItem('session-id', uuid);
		}

		return {
			newListAvailable,
		}
	}

	getId()

	let uuid = uuidv4();

	const nextStep = async () => {
		step++
		if (step > 4) {
			await fetch(`end.php/?list=${wordsListNumber}&form=${formId}`);
			window.location.replace('https://www.limesurvey.cifss.ulaval.ca/index.php/159735/lang-fr')
		}
	}

	let practiceWords: string[]

	switch (wordsListNumber) {
		case 4:
			practiceWords = ["dessiner", "manger", "espérer", "comprendre"]
			break;
		case 7:
			practiceWords = ["couper", "manger", "avoir", "vivre"]
			break;
		case 8:
			practiceWords = ["lire", "manger", "espérer", "comprendre"]
			break;
		case 11:
			practiceWords = ["lire", "coudre", "espérer", "comprendre"]
			break;
		default:
			practiceWords = ["couper", "manger", "espérer", "comprendre"]
			break;
	}

	practiceWords = shuffle(practiceWords)

</script>

{#if formId !== undefined && !error}
	{#if newListAvailable}
		{#if step === 0}
			<Instruction instructions={instructions[0]} on:done={nextStep}/>
		{:else if step === 1}
			<Text on:done={nextStep}>On commence avec une petite pratique.</Text>
		{:else if step === 2}
			<WordsRating words={practiceWords} on:done={nextStep} {uuid} listNumber={12} formNumber={formId} practice={true} let:word>
				<div style="text-align: center;">
					<Questions {word} formNumber={formId} />
				</div>
			</WordsRating>
		{:else if step === 3}
			<Text on:done={nextStep}>Très bien ! Êtes-vous prêt(e) à commencer ? Appuyez sur SUIVANT pour commencer. </Text>
		{:else if step === 4}
			{#if loading}
			<div style="height: 100%; width:100%; display:flex">
				<Loading />
			</div>
			{:else}
			<WordsRating {words} on:done={nextStep} {uuid} listNumber={wordsListNumber} formNumber={formId} let:word>
				<Questions {word} formNumber={formId} />
			</WordsRating>
			{/if}
		{:else if step === 5}
			<div style="height: 100%; width:100%; display:flex">
				<Loading />
			</div>
		{/if}
	{:else}
		Wow! Nous ne pensions pas que vous vous rendriez jusque là. Vous avez épuisé la liste de mots! Merci de votre participation.
	{/if}
	{:else}
	<div style="height: 100%; width:100%; display:flex">
		<Loading />
	</div>
{/if}